var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-swiper-item",style:({
    width: _vm.$parent.offsetWidth - _vm.gap + 'px',
    height: _vm.$parent.height + 'px',
    transform: `translateX(${_vm.offsetWidth}px)`,
    transition: `transform ${_vm.delay}ms`,
    'z-index': _vm.zIndex,
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }